import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[appLoading]',
})
export class LoadingDirective {
  hostNativeElement;

  constructor(private renderer: Renderer2, hostElement: ElementRef) {
    this.hostNativeElement = hostElement.nativeElement;
  }

  @Input() set appLoading(display: boolean) {
    if (display === true) {
      // show spinner
      this.renderer.addClass(this.hostNativeElement, 'is-loading');
    } else {
      // show default text
      this.renderer.removeClass(this.hostNativeElement, 'is-loading');
    }
  }
}
